import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class PodcastsService {

    private podcastIndexSource = new BehaviorSubject<any | null>(null);
    podcastIndex$ = this.podcastIndexSource.asObservable();

    play(podcast): void {
        this.podcastIndexSource.next(podcast);
    }
}
